import React from 'react';

import SearchIcon from '@material-ui/icons/Search';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';

import Console from '../../../lib/debug';

export default class CalendarDrawerHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: ''
        };
    }
    handleSearch(event) {
        let val = event.target.value;
        if (val !== this.state.search) {
            let newState = {
                ...this.state,
                search: val
            };
            this.setState(newState);
            this.props.onSearch(val);
        }
    }
    handleChange(val) {
        this.props.onChange(val);
    }
    onSearchClick() {
        this.$search.focus();
    }
    render() {
        Console.render('CalendarDrawerHeader');

        let buttons = this.props.items.map(item => (
            <Button
                key={item.tab}
                className={this.props.active === item.tab ? 'active' : ''}
                onClick={this.handleChange.bind(this, item.tab)}
            >
                {item.title}
            </Button>
        ));

        return (
            <div className="h-tabs">
                <div className="search">
                    <SearchIcon className="icon" />
                    <TextField
                        id="search"
                        label=""
                        placeholder="Search For..."
                        type="search"
                        fullWidth
                        margin="normal"
                        onChange={this.handleSearch.bind(this)}
                    />
                </div>
                <div className="tabs">{buttons}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/calendar/calendar-library-drawer/CalendarDrawerHeader.jsx